import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=12264003&scoped=true&"
import script from "./QRCode.vue?vue&type=script&lang=ts&"
export * from "./QRCode.vue?vue&type=script&lang=ts&"
import style0 from "./QRCode.vue?vue&type=style&index=0&id=12264003&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12264003",
  null
  
)

export default component.exports